
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/deployable/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pages-pages-reference-deployable-demo-base","pages-pages-reference-deployable-demo-children"],
  getter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/deployable/index.md?type=demo')
};